var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1437 0H2.8563C1.28 0 0 1.28 0 2.8563V13.1407C0 14.717 1.28 15.997 2.8563 15.997H13.1407C14.717 15.997 15.997 14.717 15.997 13.1407V2.8563C15.997 1.28 14.717 0 13.1407 0H13.1437ZM14.8593 13.1437C14.8593 14.0919 14.0919 14.8593 13.1437 14.8593H2.8563C1.90815 14.8593 1.14074 14.0919 1.14074 13.1437V2.8563C1.14074 1.90815 1.90815 1.14074 2.8563 1.14074H13.1407C14.0889 1.14074 14.8563 1.90815 14.8563 2.8563V13.1407L14.8593 13.1437Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8562 7.42815H8.57178V5.14371C8.57178 4.82667 8.31696 4.57185 7.99993 4.57185C7.68289 4.57185 7.42807 4.82667 7.42807 5.14371V7.42815H5.14363C4.82659 7.42815 4.57178 7.68296 4.57178 8C4.57178 8.31704 4.82659 8.57185 5.14363 8.57185H7.42807V10.8563C7.42807 11.1733 7.68289 11.4281 7.99993 11.4281C8.31696 11.4281 8.57178 11.1733 8.57178 10.8563V8.57185H10.8562C11.1733 8.57185 11.4281 8.31704 11.4281 8C11.4281 7.68296 11.1733 7.42815 10.8562 7.42815Z",
    fill: "#1C1C1C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.2dc6f1781770e9d25c79bd49bf8b22ad.svg";
export { ForwardRef as ReactComponent };